import React, { useEffect, useRef, useState } from "react";
import "./Statsstrip.css";

const stats = [
  { value: 4,   suffix: "",   label: "Events Per Year",    duration: 800  },
  { value: 15,  suffix: "+",  label: "Years of Experience", duration: 1200 },
  { value: 200, suffix: "+",  label: "Vendors Per Event",  duration: 1600 },
  { value: 1,   suffix: "",   label: "Community",          duration: 600  },
];

const useCountUp = (target, duration, triggered) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!triggered) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [triggered, target, duration]);

  return count;
};

const StatItem = ({ value, suffix, label, duration, triggered, index }) => {
  const count = useCountUp(value, duration, triggered);

  return (
    <div
      className="stat-item"
      style={{ transitionDelay: `${index * 0.12}s` }}
    >
      <div className="stat-number">
        {count}
        <span className="stat-suffix">{suffix}</span>
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
};

const StatsStrip = () => {
  const [triggered, setTriggered] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTriggered(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-strip" ref={ref}>
      <div className={`stats-inner ${triggered ? "stats-visible" : ""}`}>
        {stats.map((stat, i) => (
          <React.Fragment key={stat.label}>
            <StatItem {...stat} triggered={triggered} index={i} />
            {i < stats.length - 1 && <div className="stat-divider" />}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};

export default StatsStrip;